import { render, staticRenderFns } from "./NotaComercialAmountNet.vue?vue&type=template&id=5c31a2d4&scoped=true"
import script from "./NotaComercialAmountNet.vue?vue&type=script&lang=js"
export * from "./NotaComercialAmountNet.vue?vue&type=script&lang=js"
import style0 from "./NotaComercialAmountNet.vue?vue&type=style&index=0&id=5c31a2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c31a2d4",
  null
  
)

export default component.exports